import { useGetModelsByRunForProject } from "modules/projects/api";

import * as flowConfig from "flows/forecasting/config";
import { ForecastingProject } from "flows/forecasting/interfaces";

export const getDataFileId = (project: ForecastingProject) =>
  project.data_files[flowConfig.INPUT_DATA];

export const getTargetVariable = (project: ForecastingProject) =>
  project.meta_data[flowConfig.TARGET_VAR_KEY];

export const getTimeVariable = (project: ForecastingProject) =>
  project.meta_data[flowConfig.TIMESTAMP_VAR_KEY];

export const getGroupingVariables = (project: ForecastingProject) =>
  project.meta_data[flowConfig.GROUPING_VARS_KEY] || [];

export const useGetModelsByRun = (project: ForecastingProject) =>
  useGetModelsByRunForProject(
    project,
    flowConfig.RUN_ID,
    flowConfig.TIME_STAMP
  );
